/*
 * 
 * API calls and map setup
 * 
 */

function ms_getSettings() {
    var $ = jQuery;
    $.ajax({
        type: "POST",
        cache: false,
        url: "/services/marketing/MapSearchService.asmx/GetSettings",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "{ currentItemId: '" +
            $('#hfCurrentItemId').val() +
            "', settingsId: '" +
            $('#hfSettingsId').val() +
            "', language: '" +
            $('#hfCurrentLanguage').val() +
            "', mapType: '" +
            $('#hfMapType').val() +
            "' }",
        success: function (result) {
            ms_init(result.d);
        },
        error: function (request, status, error) {
        }
    });
}

function ms_sendDealersEmail() {
    var $ = jQuery;

    var formFields = [];
    $(".ms_contactForm_element input, .ms_contactForm_element textarea ").each(function () {
        formFields.push({
            id: $(this).attr("data-id"),
            FieldValue: $(this).val() || $(this).is(':checked')
        })
    });

    $.ajax({
        type: "POST",
        cache: false,
        url: "/services/marketing/MapSearchService.asmx/SubmitForm",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "{ currentItemId: '" + $('#hfCurrentItemId').val() +
            "', language: '" + $('#hfCurrentLanguage').val() +
            "', form: " + JSON.stringify(formFields) +
            " }",
        success: function (result) {
            ms_showFormSucessMessage(result);
        },
        error: function (request, status, error) {
        }
    });
}

function ms_getContacts() {
    var $ = jQuery;
    $.ajax({
        type: "POST",
        cache: false,
        url: "/services/marketing/MapSearchService.asmx/GetContacts",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "{ currentItemId: '" +
            $('#hfCurrentItemId').val() +
            "', language: '" +
            $('#hfCurrentLanguage').val() +

            "' }",
        success: function (result) {
            ms_markers = result.d;
            ms_pins(ms_markers);

            if (!ms_has_valid_url_prams) {
                $('#mapSearchLoad').addClass("fadeout");
            } else {
                ms_show_filtered_list();
            }

        },
        error: function (request, status, error) {
        }
    });
}
function ms_getContactsById(pspId, fn) {
    var $ = jQuery;

    $.ajax({
        type: "POST",
        cache: false,
        async: false,
        url: "/services/marketing/MapSearchService.asmx/GetContactsById",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "{ currentItemId: '" +
            $('#hfCurrentItemId').val() +
            "', language: '" +
            $('#hfCurrentLanguage').val() +
            "',pspId: '" + pspId +
            "' }",
        success: function (result) {
            fn(result.d);
        },
        error: function (request, status, error) {
        }
    });
}

/*
 * Start inserting the map. Create a Global var ms_Map to access it from other functions/scripts, and the settings var too
 */
var ms_Settings;
var ms_Map;
//I also create a Global info window var
var ms_infoWindow = false;
//the markers object
var ms_markers;
//the markers in the map object
var ms_markers_map;
//and the pin colors object
var ms_colors = {};
//distances from location
var ms_distances;
//original template for "more info"
var ms_more_info_template = false;
//closest markers to selected position (near me or search)
var ms_closest = [];
//filters
var ms_filters;
//available filters
var ms_av_filters = [];
//url parameters
var ms_url_params;
//switch statuss
var ms_switchStatus = false;
//search location
var ms_place;
//filtered products
var ms_filtered;
//mobile view option list/map
var ms_mobile_view_option = 'list';
var ms_has_valid_url_prams = true;
var ms_location_geometry;
var ms_max_distance_allowed = 10;

var last_place_searched = null;


function updateLastPlace(place_id) {
    var new_id = place_id;
    if (new_id !== last_place_searched) {
        last_place_searched = new_id;
        // reset filters
        ms_clearAllFilters();

    }
}
function ms_init(ms) {

    //define settigns
    ms_Settings = ms;
    // Need to set default value of list results to 30
    ms_Settings.TotalSearchResults = !ms_Settings.TotalSearchResults ? 30 : ms_Settings.TotalSearchResults;

    if (ms_Settings.DefaultDistance) {
        ms_max_distance_allowed = ms_Settings.DefaultDistance;
    }

    //check if url has parameters
    ms_url_params = getJsonFromUrl();
    if (
        ms_url_params.hasOwnProperty('loc') ||
        ms_url_params.hasOwnProperty('maptype') ||
        ms_url_params.hasOwnProperty('subtypes') ||
        ms_url_params.hasOwnProperty('status') ||
        ms_url_params.hasOwnProperty('services') ||
        ms_url_params.hasOwnProperty('products') ||
        ms_url_params.hasOwnProperty('certificates') ||
        ms_url_params.hasOwnProperty('productCount')
    ) {
        ms_has_valid_url_prams = true;
    } else {
        ms_has_valid_url_prams = false;
    }
    //start map
    ms_Map = new google.maps.Map(document.getElementById('mapSearch'), {
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative'
    });

    //define a short access var to map.
    var map = ms_Map;

    //center map on country/city in settigns
    var geocoder = new google.maps.Geocoder();
    var location = ms_Settings.MapCenter;

    if (!jQuery.isEmptyObject(ms_url_params) && ms_url_params.hasOwnProperty('loc')) {
        geocoder.geocode({ 'address': ms_url_params.loc }, function (results, status) {
            if (status == "OK" && typeof results[0].geometry.bounds !== 'undefined' && typeof results[0].geometry.location !== 'undefined') {
                ms_centerMap(results[0].geometry);
                document.getElementById('mapSearchInput').value = results[0].formatted_address;
            } else {
                //If url location is not found - use settings location
                geocoder.geocode({ 'address': location }, function (results, status) {
                    if (status == "OK") {
                        map.fitBounds(results[0].geometry.bounds);
                        map.setCenter(results[0].geometry.location);
                    } else {
                        alert("Could not find location: " + location);
                    }
                });
            }
        });
    } else {
        geocoder.geocode({ 'address': location }, function (results, status) {
            if (status == "OK") {
                ms_centerMap(results[0].geometry);
            } else {
                alert("Could not find location: " + location);
            }
        });
    }

    //switch statuss
    checkSwitchStatus();

    //load pins (clustered)
    ms_getContacts();

    //autocomplete Search Bar
    var input = document.getElementById('mapSearchInput');
    var autocomplete = new google.maps.places.Autocomplete(input, { types: ['geocode'] });
    autocomplete.bindTo('bounds', map);

    var marker = new google.maps.Marker({
        map: map
    });

    setMapView();

    // submit on press enter if no item from the autocomplete list is selected
    google.maps.event.addDomListener(input, 'keydown', function (e) {
        var suggestionSelected = document.querySelectorAll('.pac-item-selected');

        if (e.key === "Enter" && !e.triggered && (!suggestionSelected || suggestionSelected.length == 0)) {
            var ex1 = new Event('keydown');
            ex1.code = "ArrowDown";
            ex1.key = "ArrowDown";
            ex1.keyCode = 40;
            google.maps.event.trigger(this, 'keydown', ex1);

            var ex2 = new Event('keydown');
            ex2.code = "Enter";
            ex2.key = "Enter";
            ex2.keyCode = 13;
            ex2.triggered = true;
            google.maps.event.trigger(this, 'keydown', ex2);

        }
    });

    google.maps.event.addListener(autocomplete, 'place_changed', function () {

        marker.setVisible(false);
        ms_place = autocomplete.getPlace();

        if (ms_place.place_id) {

            updateLastPlace(ms_place.place_id);
            console.log('id now:', last_place_searched);
        }
        if (!ms_place.geometry) {
            return;
        }

        // If the place has a geometry, then present it on a map.
        if (ms_place.geometry.viewport) {
            map.fitBounds(ms_place.geometry.viewport);
        } else {
            map.setCenter(ms_place.geometry.location);
            map.setZoom(14);
        }

        marker.setPosition(ms_place.geometry.location);
        marker.setVisible(true);

        setListView();

        //create list of contacts nearby
        ms_list(ms_place.geometry.location);

        if (ms_has_valid_url_prams) {
            //show tags when using mapsearch with reduced/filered bucket size
            ms_set_filters(true);
        }
        //track search
        //check if we are starting
        if (ms_start) {
            ms_registerDataLayer("Start", "Search box");
            ms_start = false;
            ms_track_label = "Search box";
        }


        openDealerContactForm();

    });

    //find my location button
    document.getElementById('mapSearchLocation').onclick = function (e) {
        ms_findLocation(map);
        e.preventDefault();
    };

    //fix find my location button position after event
    const findMyLocationButton = document.getElementById("mapSearchLocation");
    findMyLocationButton.addEventListener("click", function () {
        findMyLocationButton.classList.add("ms_find_mobile");
    });

    //legends box (and pin colors)
    var legs = [];
    for (var i = 0, len = ms.MapType.length; i < len; i++) {
        //create the legends
        var l = ms.MapType[i];
        if (l.IsActive) {
            var legend = [
                '<div class="mapSearchLegend">',
                '<i class="ms_pin ' + l.Pin.toLowerCase() + '"></i>',
                '<div class="mapSearchLegendText">',
                '<span>' + l.DisplayName + '</span>',
                '</div>',
                '</div>'
            ].join('');
            legs.push(legend);
            //create the colors vars for the pins
            ms_colors[l.Id] = l.Pin.toLowerCase();
        }
    }
    document.getElementById('mapSearchLegends').innerHTML = legs.join('');

    // Translate everything with texts from settings
    ms_translate();

    //create filters (for the list of points)
    ms_get_filters();

    //Grab information from input and filter
    document.querySelector('.ms_copy_link').addEventListener('click', ms_copy_link);

    document.getElementById('ms_copy_link_bar').querySelector('.ms_copy_link_bar_copy').addEventListener('click', ms_copy_to_clipboard);

    //max distance allowed
    if (ms_Settings.DisabledFilters.All || ms_Settings.DisabledFilters.Distance) {
        document.querySelector("#mapSearchList").classList.add('ms_list_distance_select_hidden');
    } else {
        createMaxDistanceSelectBox();
    }

    if (ms_Settings.Form) {
        //create dealers contact form
        createDealersContectForm();
    }

}

function fixSidebarHeight() {
    setTimeout(function () {
        var maxHeight = jQuery('#mapSearch').outerHeight();
        var headHeight = jQuery('.ms_list_head').outerHeight();
        var tags = jQuery('.ms_filter_tags').outerHeight();
        var offset = 2;
        var height = maxHeight - headHeight - tags - offset;
        jQuery('.ms_list_container').outerHeight(height);
        jQuery('.ms_filter_container').outerHeight(maxHeight - headHeight);
    }, 0)
}

function createDealersContectForm() {
    var form = ms_Settings ? ms_Settings.Form : console.log('FORM SETTINGS NOT DEFINED');
    var container = document.querySelector('.ms_contactForm_wrapper');
    var leftColumn = container.querySelector('.ms_contactForm_left');
    var rightColumn = container.querySelector('.ms_contactForm_right');
    var button = container.querySelector('div .button');

    if (form) {
        document.querySelector('.ms_contactForm_headline').innerText = form.Headline;
        for (var i = 0; i < form.Fields.length; i++) {
            var isHidden = form.Fields[i]["IsHiddenField"] == true ? "hidden" : "";

            var isTextArea = form.Fields[i]["FieldType"] == 'textarea' ? 'textarea' : 'input';
            var endOfTextArea = isTextArea ? "></textarea> " : "/>";
            var formElement = '<div class="ms_contactForm_element ' + isHidden + '"><div>' + form.Fields[i]["FieldLabel"] + '<' + isTextArea + ' type="' + form.Fields[i]["FieldType"] + '" name="' + form.Fields[i]["HubspotFieldName"] + '" data-id="' + form.Fields[i]["Id"] + '" data-required="' + form.Fields[i]["IsRequiredField"] + '" placeholder="' + form.Fields[i]["Placeholder"] + '" value="" ' + endOfTextArea + ' </div><div class="ms_contactForm_error">' + form.Fields[i]["RequiredMessageError"] + '</div></div>';

            if (form.Fields[i]["HubspotFieldName"] == "firstname" ||
                form.Fields[i]["HubspotFieldName"] == "lastname" ||
                form.Fields[i]["HubspotFieldName"] == "email" ||
                form.Fields[i]["HubspotFieldName"] == "email_subject"
            ) {
                leftColumn.insertAdjacentHTML('beforeend', formElement);
            } else if (form.Fields[i]["HubspotFieldName"] == "message") {
                rightColumn.insertAdjacentHTML('beforeend', formElement);
            } else {
                container.insertAdjacentHTML('beforeend', formElement);
            }
        }
        button.innerText = form.ButtonText;

        button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (ms_dealersForm_valid()) {
                ms_sendDealersEmail();
            }
        })
    }
}

function ms_dealersForm_valid() {
    var $ = jQuery;
    var hasError = [];
    var form = document.querySelector('.ms_contactForm');

    if (form.classList.contains('is-active')) {
        $(".ms_contactForm_element input, .ms_contactForm_element textarea").each(function (index, element) {
            var el = $(this);
            var errorMessage = el.closest('.ms_contactForm_element');
            var required = element.dataset.required;
            var isRequired = required === 'true' ? true : (required === 'false' ? false : required);

            if (isRequired) {
                if (el.val() == '' || (el.is(':checkbox') && el.is(':checked') == false)) {
                    errorMessage.addClass('has-error');
                    hasError.push(index);
                } else {
                    errorMessage.removeClass('has-error');
                }
            }
        });

        return !hasError.length > 0;
    } else {
        return false;
    }
}

function ms_showFormSucessMessage(result) {
    var success = document.querySelector('.ms_contactForm_success');
    var form = document.querySelector('.ms_contactForm');

    if (result.d && result.d[0].Key == "Success" && result.d[0].Value) {
        success.innerHTML = ms_Settings.Form.SuccessMessage;
        success.classList.add('is-active');

        setTimeout(function () {
            success.classList.remove('is-active');
            form.classList.remove('is-active');
        }, 6000)
    }
}

function ms_centerMap(geometry) {
    if (!ms_location_geometry) {
        //in init fn this variable will be set, so we can reuse it later for url params
        ms_location_geometry = geometry;
    }

    if (ms_location_geometry) {
        ms_Map.fitBounds(ms_location_geometry.bounds);
        ms_Map.setCenter(ms_location_geometry.location);
    }
}

function ms_clearAllFilters() {
    var filters = document.querySelector('.ms_filters');
    var input = filters.querySelectorAll('input');

    for (var i = 0; i < input.length; i++) {
        input[i].checked = false;
    }

    //attribute "true" for not hiding the filter section
    ms_set_filters(true);

    enableOrDisableCTA(false);

    fixSidebarHeight();
}

function isFilterOptionSelected(input) {
    var checked = false;

    if (!input) { return; }

    for (var i = 0; i < input.length; i++) {
        if (input[i].checked) {
            checked = true;
        }
    }

    return checked;
}

function enableOrDisableCTA(enable) {
    if (enable) {
        document.querySelector('.ms_infobuttons .ms_filter_apply_bot').classList.add('is-active');
        document.querySelector('.ms_infobuttons .ms_filter_clear_bot').classList.add('is-active');
    } else {
        document.querySelector('.ms_infobuttons .ms_filter_apply_bot').classList.remove('is-active');
        document.querySelector('.ms_infobuttons .ms_filter_clear_bot').classList.remove('is-active');
    }
}


function watchFilterInputs() {
    var filters = document.querySelector('.ms_filters');
    var input = filters.querySelectorAll('input');

    for (var i = 0; i < input.length; i++) {
        input[i].addEventListener('click', function (event) {

            //make possible to unselect radio input
            setRadioInputScope(this);

            //make cta buttons available
            if (isFilterOptionSelected(input)) {
                enableOrDisableCTA(true);
            } else {
                enableOrDisableCTA(false);
            }
        });
    }
}

//make possible to unselect radio input
function setRadioInputScope(radioInputField) {
    if (radioInputField.getAttribute('type') !== 'radio') {
        return;
    }
    var filters = document.querySelector('.ms_filters');
    var input = filters.querySelectorAll('input');


    if (radioInputField.dataset.checked === 'true') {
        radioInputField.checked = false;
    }

    var otherRadioInputs = Array.from(input).filter(function (element) {
        return element.getAttribute('name') === radioInputField.getAttribute('name') && element.value !== radioInputField.value;
    });

    Array.from(otherRadioInputs).forEach(function (element) {
        element.setAttribute('data-checked', false);
        element.checked = false;
    });

    radioInputField.setAttribute('data-checked', radioInputField.checked);
}

function checkSwitchStatus() {
    var switchButton = document.getElementsByClassName('ms_list_switch_position');
    //if additional sorting is enabled - Don't allow sorting when sorting by ranking
    if (!ms_Settings.DisableSorting && ms_Settings.StandardSorting !== 'ranking') {
        if (switchButton.length) {
            //check switch status if it's checked or not
            ms_switchStatus = switchButton[0].checked;
        }
    } else {
        //if additional sorting is disabled then hide it.
        //ms_list_switch_wrapper hidden by server
        var mapSearch = document.getElementById('mapSearchList');

        if (!!mapSearch) {
            mapSearch.classList.add('ms_list_swtich_hidden');
        }

    }

    //Check what the list is sorting on
    (ms_Settings.StandardSorting === 'ranking') ? ms_toggleDistanceAndFilter(false) : ms_toggleDistanceAndFilter(true);

    if (switchButton && switchButton.length > 0) {
        //add event listener on change to sort and print the list based on the choice
        switchButton[0].addEventListener('change', function () {
            var orderList = ms_filtered || ms_closest;
            if (orderList.length > ms_Settings.TotalSearchResults) {
                //if filtered by urlParams we have all the dealers in ms_filtered, we sort only the ones that are in the list and dont touch the global list
                orderList = ms_list_paginate(ms_filtered, ms_Settings.TotalSearchResults, 1)
            }

            if (this.checked) {
                ms_switchStatus = true;
                orderList ? orderList.sort(function (a, b) { return b.count - a.count }) : ms_closest.sort(function (a, b) { return b.count - a.count });
            } else {
                ms_switchStatus = false;
                orderList ? orderList.sort(function (a, b) { return a.d - b.d }) : ms_closest.sort(function (a, b) { return a.d - b.d });
            }

            orderList ? ms_print_list(orderList, true) : ms_print_list(ms_closest, true);

        });
    }

}

/* TRANSLATIONS */
function decodeHtml(text) {
    var txt = document.createElement("textarea");
    txt.innerHTML = text;
    return txt.value;
}
function ms_translate() {
    //translations
    var _t = ms_Settings.Translations;
    var pho = document.querySelectorAll("a.ms_info_phone");
    var nav = document.querySelectorAll("a.ms_i_navigation span");
    var info = document.querySelector("a.ms_i_info span"),
        services = document.querySelector(".ms_info_ad_services b"),
        otherServices = document.querySelector(".ms_info_ad_other_services b"),
        status = document.querySelector(".ms_info_ad_status b"),
        products = document.querySelector(".ms_info_ad_products b"),
        certificate = document.querySelector(".ms_info_certificate b"),
        list_filter = document.querySelector(".ms_list_filter_bot span"),
        apply = document.querySelector(".ms_filter_apply_bot span"),
        clear_filter = document.querySelector(".ms_filter_clear_bot span");
    ms_list_max_distance_label = document.querySelector(".ms_list_max_distance_label");

    //autocomplete Search Bar
    document.getElementById('mapSearchInput').setAttribute("placeholder", decodeHtml(_t.search_bar_placeholder));
    //find my location
    document.querySelector("#mapSearchLocation span").innerHTML = _t.find_near_me;

    //pin infobox
    for (var i = 0, len = nav.length; i < len; i++) {
        pho[i].innerHTML = _t.show_phone_number_text;
        nav[i].innerHTML = _t.navigate_button_label;
    }

    info !== null ? info.innerHTML = _t.more_info_button_label : '';
    services !== null ? services.innerHTML = _t.map_services_label + ":" : '';
    otherServices !== null ? otherServices.innerHTML = _t.other_services_label ? _t.other_services_label + ":" : 'Other Services' : '';
    status !== null ? status.innerHTML = _t.map_status_label + ":" : '';
    products !== null ? products.innerHTML = _t.map_products_label + ":" : '';
    certificate !== null ? certificate.innerHTML = _t.map_certificates_label + ":" : '';
    //markers list
    list_filter !== null ? list_filter.innerHTML = _t.filter_text : '';
    apply !== null ? apply.innerHTML = _t.apply_button_text : '';
    clear_filter !== null ? clear_filter.innerHTML = _t.clear_filter_button_text : '';
    ms_list_max_distance_label !== null ? ms_list_max_distance_label.innerHTML = _t.ms_list_max_distance_label_text ? _t.ms_list_max_distance_label_text : 'Distance:' : '';
}

/* Find location */

function ms_findLocation(map) {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };

            var marker = new google.maps.Marker({
                position: pos,
                map: map
            });

            infoWindowMapSearch(map, marker);

            //show address in search bar
            var geocoder = new google.maps.Geocoder;
            geocoder.geocode({ 'location': pos }, function (results, status) {
                if (status === 'OK') {
                    document.getElementById('mapSearchInput').value = results[0].formatted_address;
                } else {
                    console.log('No results found');
                }
            });


            //create list of contacts nearby
            ms_list(new google.maps.LatLng(pos));

            //tracks the click
            if (ms_start) {
                ms_registerDataLayer("Start", "Find nearest");
                ms_start = false;
                ms_track_label = "Find nearest";
            }
        }, function () {
            handleLocationError(true, map.getCenter());
        });
    } else {
        // Browser doesn't support Geolocation
        handleLocationError(false, map.getCenter());
    }
}

function handleLocationError(browserHasGeolocation, pos) {
    var txt = browserHasGeolocation ? 'Error: The Geolocation service failed.' : 'Error: Your browser doesn\'t support geolocation.';
    alert(txt);
}

/* Markers */
function update_markers_on_map(loc) {
    if (!loc.length) {
        removeCluster();
    } else {
        ms_pins(loc, true);
    }
}

function removeCluster() {
    var markers = window.markerCluster.getMarkers();
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    window.markerCluster.removeMarkers(markers);
    window.markerCluster.clearMarkers();
    ms_markers_map = [];
    markers = [];
}

function ms_pins(loc, updateMap) {
    var bounds = new google.maps.LatLngBounds();
    var cluster_styles = [
        {
            width: 40,
            height: 40,
            url: getClusterInlineSvg('#28231f'),
            textColor: 'white',
            textSize: 12
        },
        {
            width: 50,
            height: 50,
            url: getClusterInlineSvg('#28231f'),
            textColor: 'white',
            textSize: 14
        },
        {
            width: 60,
            height: 60,
            url: getClusterInlineSvg('#28231f'),
            textColor: 'white',
            textSize: 16
        }
    ];

    if (updateMap) {
        //first remove all the markers
        removeCluster();

        //filter the map based on the filter settings
        ms_markers_map = loc.map(function (location, i) {
            bounds.extend(new google.maps.LatLng(parseFloat(location.info.loc.lat), parseFloat(location.info.loc.lng)));
            return new google.maps.Marker({
                position: new google.maps.LatLng(parseFloat(location.info.loc.lat), parseFloat(location.info.loc.lng)),
                icon: pinSymbolMapSearch(ms_colors[location.info.Type]),
                ms_id: location.info.PspId
            });
        });
        //ms_centerMap();
        //ms_Map.setZoom(11);

    } else {
        ms_markers_map = loc.Data.map(function (location, i) {
            bounds.extend(new google.maps.LatLng(parseFloat(location.loc.lat), parseFloat(location.loc.lng)));
            return new google.maps.Marker({
                position: new google.maps.LatLng(parseFloat(location.loc.lat), parseFloat(location.loc.lng)),
                icon: pinSymbolMapSearch(ms_colors[location.Type]),
                ms_id: location.PspId
            });
        });

    }

    // Add a marker clusterer to manage the markers.
    window.markerCluster = new MarkerClusterer(ms_Map, ms_markers_map, { styles: cluster_styles, maxZoom: 10 });

    //add click event to markers/pins
    for (var i = 0, len = ms_markers_map.length; i < len; i++) {
        ms_markers_map[i].addListener('click', function () {
            pinInfoMapSearch(this.ms_id, ms_Map, this);
        });
    }
}

function getClusterInlineSvg(color) {
    var encoded = window.btoa('<svg viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><desc>Created with Sketch.</desc><defs></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><circle id="Oval" fill="' + color + '" cx="15" cy="15" r="15"></circle></g></svg>');
    return ('data:image/svg+xml;base64,' + encoded);
};


//function to create custom SVG marker
function pinSymbolMapSearch(color) {
    return {
        path: 'M40,114.007954 C13.3333333,79.3969115 0,54.7275933 0,40 C0,17.90861 17.90861,0 40,0 C62.09139,0 80,17.90861 80,40 C80,54.7275933 66.6666667,79.3969115 40,114.007954 Z M40,56 C48.2842712,56 55,49.2842712 55,41 C55,32.7157288 48.2842712,26 40,26 C31.7157288,26 25,32.7157288 25,41 C25,49.2842712 31.7157288,56 40,56 Z',
        fillColor: getHexColor(color),
        fillOpacity: 1,
        scale: 0.25
    };
}

// get hex color code
function getHexColor(color) {
    switch (color) {
        case 'red':
            return "#ee0000";
            break;
        case 'darkred':
            return "#A11515";
            break;
        case 'blue':
            return "#A9CAE5";
            break;
        case 'darkblue':
            return "#476996";
            break;
        case 'gray':
            return "#7b7a79";
            break;

    }
}


//get info of given ID
function ms_get_info(id) {
    var info = ms_markers.Data.filter(function (obj) {
        return obj.PspId === id;
    })[0];
    return info;
}

//get marker by ID
function ms_get_marker(id) {
    var mk = ms_markers_map.filter(function (obj) {
        return obj.ms_id === id;
    })[0];
    return mk;
}

/* Tooltip */

//get info of pin/list item and creates a tooltip in place
function pinInfoMapSearch(id, map, pos) {
    var info = ms_get_info(id);

    //show tooltip
    infoWindowMapSearch(map, pos, id);

    //track that click!
    //check if we are starting
    if (ms_start) {
        ms_registerDataLayer("Start", "Click on map");
        ms_start = false;
    }
    ms_registerDataLayer(info.FullName, info.FullAddress + " | " + info.Telephone1);
}


function choose_view_option(view) {
    //remove active items from all icons
    if (view === 'map') {
        setMapView();
    } else {
        setListView();
        //clear data if switched to list view
        document.querySelector('.ms_list_item_map_view').innerHTML = '';
    }
}

//create or modify info window
function infoWindowMapSearch(map, position, id) {
    remove_active_class_from_ms_list_items();

    if (!ms_closest.length) {
        ms_print_list(false, true, ms_get_info(id));
    } else if (ms_mobile_view_option === 'map' && window.innerWidth <= 768) {
        ms_print_list(ms_closest, true, ms_get_info(id));
    }

    var item = document.querySelector('.ms_list_item[data-id="' + id + '"]');

    //open card when clicking on the marker 
    item.classList.add('ms_list_item_clicked');

    //scroll to that item to make it visible
    scroll_to_ms_list_item();

    //get more info for item
    ms_more_info(id);

    //position map
    if (window.innerWidth >= 768) {
        map.setZoom(15);
    }

    setTimeout(function () {
        map.setCenter(position.getPosition());
    }, 0);
}

//info window button functions
function ms_showPhone(e) {
    e.preventDefault();

    var t = e.target;
    t.style.display = "none";
    t.nextElementSibling.style.display = "block";
}

//list of locations close to user
function ms_list(pos) {
    ms_distances = [];

    var locs = ms_markers.Data;
    for (var i = 0, len = locs.length; i < len; i++) {
        var distance = google.maps.geometry.spherical.computeDistanceBetween(pos, new google.maps.LatLng({ lat: parseFloat(locs[i].loc.lat), lng: parseFloat(locs[i].loc.lng) }));
        if (isNaN(distance)) distance = 99999999999;

        //we are changing to miles/km when we show the list, pushing default distance here,but checking allowance in miles or km based on settings.
        var currentDistance;
        if (ms_Settings.DistancesInMiles) {
            currentDistance = distance * 0.00062137;
        } else {
            currentDistance = distance / 1000
        }
        if (ms_Settings.DisabledFilters.All || ms_Settings.DisabledFilters.Distance) {
            ms_distances.push({ d: distance, count: locs[i].ProductCount, id: locs[i].PspId });
        } else {
            if (currentDistance <= ms_max_distance_allowed) {
                ms_distances.push({ d: distance, count: locs[i].ProductCount, id: locs[i].PspId });
            }
        }

    }

    //get the array of all distances and sort it from lower to higher
    ms_distances.sort(function (a, b) { return a.d - b.d });

    //extract the first X results

    // #############
    // ######  Amount is hardcoded right here. ######
    // ######
    var closest = ms_list_paginate(ms_distances, ms_Settings.TotalSearchResults, 1);
    //get the full data for these pins and add it to them
    if (ms_switchStatus) {
        closest.sort(function (a, b) { return b.count - a.count });
    }

    var closeids = [];
    for (var i = 0, len = closest.length; i < len; i++) {
        closeids.push(closest[i].id);
    }
    ms_getContactsById(closeids.join(','), function (d) {
        for (var i = 0, len = closest.length; i < len; i++) {
            closest[i].info = d.Data.filter(function (obj) {
                return obj.PspId == closest[i].id;
            })[0];
        }

        //if sorting by ranking points, re-sort the list
        if (ms_Settings.StandardSorting === 'ranking') {
            closest = sortByRanking(closest);
        }

        //make the closest list global
        ms_closest = closest;
        //print list
        ms_print_list(closest, true);

        //also, reset filter selects
        var sel = document.querySelectorAll('.ms_filters select');
        for (var i = 0, len = sel.length; i < len; i++) {
            sel[i].selectedIndex = 0;
        }
        // reset multiList 
        var multiSel = document.querySelectorAll('.ms_filter_container > .ms_filters > .ms_filter .ms_selectMultiList label > input[type="checkbox"]');
        if (multiSel.length) {
            for (var ii = 0, lenn = multiSel.length; ii < lenn; ii++) {
                multiSel[ii].checked = false;
            }
            //remove active class from the multilist after all checkboxes are unchecked
            var labels = document.querySelectorAll('.ms_filter_container > .ms_filters > .ms_filter .ms_selectMultiList_label');
            for (var iii = 0, lennn = labels.length; iii < lennn; iii++) {
                labels[iii].classList.remove('is-active')
            }
        }
    });
}

function getLocationOrCountry() {
    //if location will not be set it will take country base point from settings
    return !jQuery.isEmptyObject(ms_url_params) && ms_url_params.hasOwnProperty('loc') ? ms_url_params.loc : ms_Settings.MapCenter;
}

function setDealersIdsInArray(closest) {
    var closeids = [];
    for (var i = 0, len = closest.length; i < len; i++) {
        closeids.push(closest[i].id);
    }

    return closeids;
}

function setFilterList(closest, dontPrintList) {

    //if sorting by ranking points, re-sort the list
    if (ms_Settings.StandardSorting === 'ranking') {
        closest = sortByRanking(closest);
    }

    //print list
    if (!dontPrintList) {
        //make the closest list global
        ms_closest = closest;
        ms_print_list(closest, true);
    }

    //filter by params
    if (ms_has_valid_url_prams) {
        //set filter values
        if (ms_url_params.hasOwnProperty('maptype')) {
            jQuery("#mapSearchList .ms_filters [data-category='MapType'][value=" + ms_url_params.maptype + "]:enabled").click();
        }
        if (ms_url_params.hasOwnProperty('subtypes')) {
            jQuery("#mapSearchList .ms_filters [data-category='SubTypes'][value=" + ms_url_params.subtypes + "]:enabled").click();
        }
        if (ms_url_params.hasOwnProperty('status')) {
            jQuery("#mapSearchList .ms_filters [data-category='Status'][value=" + ms_url_params.status + "]:enabled").click();
        }
        if (ms_url_params.hasOwnProperty('services')) {
            jQuery("#mapSearchList .ms_filters [data-category='Services'][value=" + ms_url_params.services + "]:enabled").click();
        }
        if (ms_url_params.hasOwnProperty('products')) {
            //as products are multi selectable, need to split string and choose all items in the list seperated by comma
            var productsArray = ms_url_params.products.split(',');

            for (var productIndex = 0; productIndex < productsArray.length; productIndex++) {
                jQuery("#mapSearchList .ms_filters [data-category='Products'][value=" + productsArray[productIndex] + "]:enabled").click();
            }

        }
        if (ms_url_params.hasOwnProperty('certificates')) {
            //as Certificates are multi selectable, need to split string and choose all items in the list seperated by comma
            var CertificatesArray = ms_url_params['certificates'].split(',');

            for (var CertificateIndex = 0; CertificateIndex < CertificatesArray.length; CertificateIndex++) {
                jQuery("#mapSearchList .ms_filters [data-category='Certificates'][value=" + CertificatesArray[CertificateIndex] + "]:enabled").click();
            }

        }
        if (ms_url_params.hasOwnProperty('ProductCount')) {
            jQuery("#mapSearchList .ms_filters [data-category='ProductCount'][value=" + ms_url_params.ProductCount + "]:enabled").click();
        }

        //if we dont have a location set in urls, and we have reduced backet installers, we just select the filter options but dont show it.
        if (!dontPrintList) {
            //show filter tab, its toggled again in ms_set_filters()
            ms_filter_display();
        }


        ms_set_filters();
        jQuery('#mapSearchLoad').addClass("fadeout");
    }
}

//show location and apply filters from url params
//used on page load when parameters are specified
function ms_show_filtered_list() {
    var geocoder = new google.maps.Geocoder();
    var location = getLocationOrCountry();

    //overwrite default location
    if (location) {
        geocoder.geocode({ 'address': location }, function (results, status) {
            //overwrite only if location was found
            if (status == "OK" && typeof results[0].geometry.bounds !== 'undefined' && typeof results[0].geometry.location !== 'undefined') {
                var resultBounds = new google.maps.LatLngBounds(
                    results[0].geometry.viewport.getSouthWest(),
                    results[0].geometry.viewport.getNorthEast()
                );

                ms_Map.fitBounds(results[0].geometry.bounds);
                ms_Map.setCenter(results[0].geometry.location);
                document.getElementById('mapSearchInput').value = results[0].formatted_address;
                var pos = ms_Map.center;
                ms_distances = [];
                var locs = ms_markers.Data;
                for (var i = 0, len = locs.length; i < len; i++) {
                    var distance = google.maps.geometry.spherical.computeDistanceBetween(pos, new google.maps.LatLng({ lat: parseFloat(locs[i].loc.lat), lng: parseFloat(locs[i].loc.lng) }));
                    if (isNaN(distance)) distance = 99999999999;
                    ms_distances.push({ d: distance, count: locs[i].ProductCount, id: locs[i].PspId });
                }
                //get the array of all distances and sort it from lower to higher
                ms_distances.sort(function (a, b) { return a.d - b.d });

                var closest = ms_distances;
                var closeids = [];

                //if location is not set, need to get data for all dealers as we are filtering country scope not city scope
                if (ms_Settings.MapCenter === location && ms_has_valid_url_prams) {
                    closeids = setDealersIdsInArray(ms_distances)

                    var chunkLimit = 100;
                    var temparray;
                    var contactData = [];

                    for (var ii = 0; ii <= closeids.length; ii += chunkLimit) {
                        var spliceLimit = ii + chunkLimit;
                        temparray = closeids.slice(ii, spliceLimit);


                        ms_getContactsById(temparray.join(','), function (d) {

                            for (var j = 0; j < d.Data.length; j++) {
                                contactData.push(d.Data[j]);
                            }

                            if (spliceLimit > closeids.length) {
                                //its last iterations

                                for (var k = 0; k < closest.length; k++) {
                                    closest[k].info = contactData.filter(function (obj) {
                                        return obj.PspId == closest[k].id;
                                    })[0];
                                }


                                var dontPrintList = true;
                                setFilterList(closest, dontPrintList);
                                reduce_dealers(closest);
                                update_markers_on_map(ms_filtered, true);
                            }
                        });
                    }
                } else {
                    //extract the first X results
                    closest = ms_list_paginate(ms_distances, ms_Settings.TotalSearchResults, 1);
                    closeids = setDealersIdsInArray(closest);

                    //get the full data for these pins and add it to them
                    ms_getContactsById(closeids.join(','), function (d) {
                        for (var i = 0, len = closest.length; i < len; i++) {
                            closest[i].info = d.Data.filter(function (obj) {
                                return obj.PspId == closest[i].id;
                            })[0];
                        }


                        setFilterList(closest);
                    });
                }
            }
        });
    }
}



function show_mobile_map_view_list_item(marker_info) {
    if (!marker_info) { return; }
    var container = document.querySelector('#mapSearchList .ms_list_container');
    var mobile_container = document.querySelector('.ms_list_item_map_view');
    mobile_container.innerHTML = '';
    //set active class in list view
    var list_active_item = container.querySelector('.ms_list_item[data-id="' + marker_info.PspId + '"]');
    list_active_item.classList.add('ms_list_item_clicked');
    var activeListItem = container.querySelector('.ms_list_item.ms_list_item_clicked').cloneNode(true);

    mobile_container.appendChild(activeListItem);
}

function hide_view_options() {
    document.querySelector('.ms_view_options').classList.add('is-hidden');
}

function show_view_options() {
    document.querySelector('.ms_view_options').classList.remove('is-hidden');
}

function setMapView() {
    document.getElementById('mapSearchContainer').classList.remove('ms_view_list');
    document.getElementById('mapSearchContainer').classList.add('ms_view_map');
    ms_mobile_view_option = 'map';
}

function setListView() {
    document.querySelector('.ms_view_options').classList.remove('is-hidden');
    document.getElementById('mapSearchContainer').classList.add('ms_view_list');
    document.getElementById('mapSearchContainer').classList.remove('ms_view_map');

    ms_mobile_view_option = 'list';
}

function switchAdditionalFeatures(status) {
    var listResults = document.querySelector('#mapSearchList .ms_list_results'),
        listSwitch = document.querySelector('#mapSearchList .ms_list_switch_wrapper'),
        infoButtons = document.querySelector('#mapSearchList .ms_infobuttons');

    if (status === 'hide') {
        listResults !== null ? listResults.classList.add('is-hidden') : '';
        listSwitch !== null ? listSwitch.classList.add('is-hidden') : '';
        infoButtons !== null ? infoButtons.classList.add('is-hidden') : '';
    } else if (status === 'show') {
        listResults !== null ? listResults.classList.remove('is-hidden') : '';
        listSwitch !== null ? listSwitch.classList.remove('is-hidden') : '';
        infoButtons !== null ? infoButtons.classList.remove('is-hidden') : '';
    }
}

//build list of closest places and print it
function ms_print_list(closest, shrink, marker_info) {
    var items = [];
    var container = document.querySelector('#mapSearchList .ms_list_container');
    var list_item_dom;
    var mapSearch = document.getElementById('mapSearch');

    if (closest) {
        update_markers_on_map(closest, true);
    }

    //marker_info - display only one list item if search in not used
    if (marker_info && !closest) {
        container.innerHTML = '';
        //if there are no closest items dont list/map options
        hide_view_options();
        list_item_dom = document.querySelector('.ms_list_itemLayout .ms_list_item').cloneNode(true);
        //translations
        list_item_dom.querySelector('.ms_info_email').innerHTML = (ms_Settings.Translations.product_send_email_label || 'Send email');
        list_item_dom.querySelector('.ms_info_web span').innerHTML = (ms_Settings.Translations.product_web_address || 'Webaddress');
        list_item_dom.querySelector('.ms_info_times_label').innerHTML = (ms_Settings.Translations.product_info_times_label || 'Opening hours');
        list_item_dom.classList.add('ms_list_item_clicked');
        list_item_dom.setAttribute('data-id', marker_info.PspId);
        list_item_dom.querySelector('.ms_list_info_title').innerHTML = marker_info.FullName;
        list_item_dom.querySelector('.ms_list_info_address').innerHTML = marker_info.FullAddress;
        list_item_dom.querySelector('.ms_list_info_productCount').innerHTML = marker_info.ProductCount ? '<i>' + (ms_Settings.Translations.product_count_label || "Products on display") + ": " + marker_info.ProductCount + '</i>' : '';
        list_item_dom.removeChild(list_item_dom.querySelector('.ms_list_expand'));
        list_item_dom.removeChild(list_item_dom.querySelector('.ms_list_collapse'));

        container.appendChild(list_item_dom);

        if (!mapSearch.classList.contains('ms_listed')) {
            mapSearch.classList.add('ms_listed');
        }

        //if only one result don't show additional features
        switchAdditionalFeatures('hide');
        //hide max distance selection if one result 
        document.querySelector(".ms_list_max_distance_wrapper").classList.add('is-hidden')

        //show at the bottom of the map marker info seperated from the list view as map view 
        if (ms_mobile_view_option === 'map' && window.innerWidth < 768) {
            show_mobile_map_view_list_item(marker_info);
        }

    } else if (marker_info && ms_mobile_view_option === 'map' && closest) {
        show_mobile_map_view_list_item(marker_info);
        show_view_options();
    } else {
        container.innerHTML = '';
        show_view_options();
        for (var i = 0, len = closest.length; i < len; i++) {
            var distance = '<span>' + (closest[i].d / 1000).toFixed(1).replace(".0", '') + ' km</span>';

            if (ms_Settings.DistancesInMiles) {
                distance = '<span>' + (closest[i].d * 0.00062137).toFixed(1).replace(".0", '') + ' mi</span>';
            }

            //clone
            list_item_dom = document.querySelector('.ms_list_itemLayout .ms_list_item').cloneNode(true);
            //translations
            list_item_dom.querySelector('.ms_list_expand').innerHTML = (ms_Settings.Translations.product_expand_label || 'Expand');
            list_item_dom.querySelector('.ms_list_collapse').innerHTML = (ms_Settings.Translations.product_collapse_label || 'Collapse');
            list_item_dom.querySelector('.ms_info_email').innerHTML = (ms_Settings.Translations.product_send_email_label || 'Send email');
            list_item_dom.querySelector('.ms_info_web span').innerHTML = (ms_Settings.Translations.product_web_address || 'Webaddress');
            list_item_dom.querySelector('.ms_info_times_label').innerHTML = (ms_Settings.Translations.product_info_times_label || 'Opening hours');
            list_item_dom.setAttribute('data-id', closest[i].id);
            list_item_dom.querySelector('.ms_list_info_title').innerHTML = closest[i].info.FullName;
            list_item_dom.querySelector('.ms_list_info_address').innerHTML = closest[i].info.FullAddress;
            list_item_dom.querySelector('.ms_list_info_productCount').innerHTML = closest[i].info.ProductCount ? '<i>' + (ms_Settings.Translations.product_count_label || "Products on display") + ": " + closest[i].info.ProductCount + '</i>' : '';
            list_item_dom.querySelector('.ms_list_distance').innerHTML = distance;

            container.appendChild(list_item_dom);


        }

        //if multiple results show show additional features
        switchAdditionalFeatures('show');
        //if multiple results show max distance
        document.querySelector(".ms_list_max_distance_wrapper").classList.remove('is-hidden')


        //assign click event to items
        var its = container.querySelectorAll('.ms_list_item');

        for (var j = 0, lenn = its.length; j < lenn; j++) {
            its[j].addEventListener('click', function (event) {
                // event.preventDefault();
                event.stopPropagation();

                //if its already opened dont execute the code
                if (this.classList.contains('ms_list_item_clicked')) {
                    if (event.target.classList.contains('ms_list_collapse')) {
                        this.classList.remove("ms_list_item_clicked");
                    }

                    return;
                }

                var id = this.getAttribute("data-id"),
                    marker = ms_get_marker(id);


                //add and remove clicked classes
                Array.prototype.forEach.call(its, function (item) {
                    item.classList.remove("ms_list_item_clicked");
                });

                pinInfoMapSearch(id, ms_Map, marker);
                scroll_to_ms_list_item();
            });
        }

        //number of results
        document.querySelector(".ms_list_results").innerHTML = its.length + " " + ms_Settings.Translations.results_found;


        //switch sort by distance or by number of products
        var applySwitchButtonTranslations = function () {
            var switchWrapper = document.querySelector(".ms_list_switch_wrapper_header"),
                distanceLabel = document.querySelector(".ms_list_switch_wrapper_label.is-distance"),
                productsLabel = document.querySelector(".ms_list_switch_wrapper_label.is-products");

            if (switchWrapper !== null) {
                switchWrapper.innerHTML = ms_Settings.Translations.product_sort_by ? ms_Settings.Translations.product_sort_by : 'Sort by:';
            }

            if (distanceLabel !== null) {
                distanceLabel.innerHTML = ms_Settings.Translations.product_sort_distance ? ms_Settings.Translations.product_sort_distance : 'Distance';

            }

            if (productsLabel !== null) {
                productsLabel.innerHTML = ms_Settings.Translations.product_sort_on_display ? ms_Settings.Translations.product_sort_on_display : 'Products on Display';
            }

        };

        applySwitchButtonTranslations();

    }
    /* If the result ID is set in URL query - execute only once on page load if url contains specific installer ID */
    openInstallerIfPsId(mapSearch);

    //if I'm coming from the initial show list function
    if (shrink) {
        var mapSearchList = document.getElementById('mapSearchList'),
            searchIcon = document.getElementById('mapSearchBar').querySelector('i');

        //show list, shrink map
        mapSearchList.classList.add('ms_listed');
        searchIcon.classList.remove("icon-search-black");
        searchIcon.classList.add('icon-cross-light');

        searchIcon.addEventListener("click", ms_list_remove_and_show_all_markers, true);

        //when I resize map, re-center it
        var center = ms_Map.getCenter();
        google.maps.event.trigger(ms_Map, 'resize');
        ms_Map.setCenter(center);


    }

    //go through filters and disable/enable available ones for this specific list of contacts
    ms_clear_filters();

    fixSidebarHeight();
}

function createMaxDistanceSelectBox() {
    var settings = ms_Settings;
    var select = document.querySelector(".ms_list_max_distance");
    if (settings && select) {
        var options = settings.Distances;
        var prefix = 'km';

        if (ms_Settings.DistancesInMiles) {
            prefix = 'mi';
        }
        if (options) {
            for (var i = 0; i < options.length; i++) {
                select.options[select.options.length] = new Option(options[i] + ' ' + prefix, options[i], ms_Settings.DefaultDistance == options[i], ms_Settings.DefaultDistance == options[i]);
            }
        }

        //add Event Listener

        select.addEventListener('change', function (event) {
            var value = event.target.value;
            ms_max_distance_allowed = value;
            ms_list(ms_place.geometry.location);
        });
    }
}

function openInstallerIfPsId(mapSearch) {
    if (ms_url_params.hasOwnProperty('pspid') && !mapSearch.classList.contains('ms_listed')) {
        var listItem = document.querySelectorAll('#mapSearchList .ms_list_item[data-id="' + ms_url_params.pspid + '"]');
        if (listItem.length > 0) {
            listItem[0].click();
            scroll_to_ms_list_item();
        }
    }
}

function remove_active_class_from_ms_list_items() {
    var its = document.querySelectorAll('#mapSearchList .ms_list_container .ms_list_item');

    if (!its) { return; }

    for (var i = 0; i < its.length; i++) {
        its[i].classList.remove("ms_list_item_clicked");
    }
}

function scroll_to_ms_list_item() {
    setTimeout(function () {
        var ms_list_container = document.querySelector("#mapSearchList .ms_list_container"),
            ms_list_item_clicked = document.querySelector('#mapSearchList .ms_list_item.ms_list_item_clicked');

        if (!ms_list_item_clicked) {
            return;
        }

        if (window.innerWidth < 768) {
            //VMS menu is fixed position need to subtract
            var vmsMenu = document.querySelectorAll(".fixedHeaderWrapper .mobile-menu");

            if (vmsMenu.length > 0) {
                var yOffset = vmsMenu[0].offsetHeight;
                var y = ms_list_item_clicked.getBoundingClientRect().top + window.pageYOffset - yOffset;

                window.scrollTo({ top: y, behavior: 'smooth' });
            } else {
                ms_list_item_clicked.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }

        } else {
            var scrollTop = ms_list_item_clicked.getBoundingClientRect().top - ms_list_container.getBoundingClientRect().top;
            var targetTop = document.querySelector("#mapSearchList .ms_list_container > *").getBoundingClientRect().top - ms_list_container.getBoundingClientRect().top;
            var scrollOffset = scrollTop - targetTop;

            ms_list_container.scrollTop = scrollOffset;
        }
    }, 300);
}

function ms_list_remove_and_show_all_markers() {
    ms_list_remove();
    ms_show_all_markers();
    ms_tags_remove();
    setMapView();
}

function ms_tags_remove() {
    document.querySelector('.ms_filter_tags').innerHTML = '';

    var filters = document.querySelectorAll('.ms_filters input');

    for (var i = 0; i < filters.length; i++) {
        filters[i].checked = false;
        filters[i].setAttribute('data-checked', false);
    }
}

//Hide the list of found items 
function ms_list_remove() {
    document.getElementById('mapSearch').classList.remove('ms_listed');
    document.getElementById('mapSearchList').classList.remove('ms_listed');
    var closeIcon = document.getElementById('mapSearchBar').querySelector('i');
    closeIcon.classList.remove('icon-cross-light');
    closeIcon.classList.add("icon-search-black");
    //closeIcon.removeEventListener("click", function () { });
    closeIcon.removeEventListener("click", ms_list_remove_and_show_all_markers, true);

    document.getElementById('mapSearchInput').value = "";
    var center = ms_Map.getCenter();
    google.maps.event.trigger(ms_Map, 'resize');
    ms_Map.setCenter(center);
    ms_closest = [];
}

//Show all markers after filter is used
function ms_show_all_markers() {
    removeCluster();
    ms_pins(ms_markers, false);
}


//paginate list of locations
function ms_list_paginate(array, page_size, page_number) {
    --page_number; // because pages logically start with 1, but technically with 0
    return array.slice(page_number * page_size, (page_number + 1) * page_size);
}

/* filter list */

//hide/show filter
function ms_filter_display() {
    var container = document.getElementById('mapSearchList');
    container.classList.toggle('ms-show-filter');
}

//get filters from settings and creates the filter list
function ms_get_filters() {
    var ms = ms_Settings;
    var _t = ms.Translations;
    var IS_MULTI_SELECTABLE = 'multiSelectable';

    ms_filters = [
        { label: _t.map_type_label, filter: ms.MapType, key: 'MapType', },
        { label: _t.map_sub_type_label, filter: ms.SubTypes, key: 'SubTypes', },
        { label: _t.map_status_label, filter: ms.Status, key: 'Status', },
        { label: _t.map_services_label, filter: ms.Services, key: 'Services', },
        { label: _t.map_products_label, filter: ms.Products, key: 'Products', type: IS_MULTI_SELECTABLE },
        { label: _t.map_certificates_label, filter: ms.Certificates, key: 'Certificates', type: IS_MULTI_SELECTABLE },
        { label: _t.product_count_label, filter: [{ "Name": (ms_Settings.Translations.product_count_label_yes || "Yes"), "Id": 1 }, { "Name": (ms_Settings.Translations.product_count_label_no || "No"), "Id": 0 }], key: 'ProductCount' }
    ];


    //print those filters
    var filters = [];
    for (var i = 0, len = ms_filters.length; i < len; i++) {

        // if filter is disabled, don't print it and skip it
        if (ms.DisabledFilters && ms_isFilterDisabled(ms_filters[i], ms.DisabledFilters)) {
            continue;
        }

        //check if filter option exists if not skip the step
        if (ms_filters[i].filter) {
            ms_filters[i].filter = ms_filters[i].filter.filter(function (el) {
                return el.hasOwnProperty('IsActive') ? el.IsActive : true;
            });
        } else {
            continue;
        }


        //check if filters aren't empty and then print them (if not)
        var lenn = ms_filters[i].filter.length;
        var options = [];
        if (lenn > 0) {

            for (var ii = 0, lenn; ii < lenn; ii++) {
                var f = ms_filters[i].filter[ii];
                var n;
                var v;
                //not all filter objects have same naming :( - MUST FIX
                //nor the object of each pin the same way of identifying what it is (ex. array with obj + id)- MUST FIX
                if (f.hasOwnProperty('DisplayName')) {
                    n = f.DisplayName;
                    v = f.Id;
                } else if (f.hasOwnProperty('SubTypeName')) {
                    n = f.SubTypeName;
                    v = f.Id;
                } else if (f.hasOwnProperty('StatusName')) {
                    n = f.StatusName;
                    v = f.Id;
                } else if (f.hasOwnProperty('CertificateName')) {
                    n = f.CertificateName;
                    v = f.Id;
                } else {
                    n = f.Name;
                    v = f.Id;
                }

                if (ms_filters[i].type && ms_filters[i].type == IS_MULTI_SELECTABLE) {
                    options.push(
                        '<label class="ms_filter_option is-checkbox">' + n + '<input type="checkbox" data-category="' + ms_filters[i].key + '" name="checkbox" value="' + v + '">',
                        '<span class="ms_filter_optionCheckBox"></span>',
                        '</label>'

                    );
                } else {
                    options.push(
                        '<label class="ms_filter_option is-radio" >' + n,
                        '<input data-category="' + ms_filters[i].key + '" type="radio" name="' + ms_filters[i].key + '" value="' + v + '">',
                        '<span class="ms_filter_optionRadio"></span>',
                        '</label> '
                    );
                }
            }

            filter = [
                '<div class="ms_filter"><div class="ms_filter_title">' + ms_filters[i].label + '</div>',
                options.join(''),
                '</div>'
            ].join('');

            filters.push(filter);

            //what filters are available?
            ms_av_filters.push(ms_filters[i].key === "MapType" ? "Type" : ms_filters[i].key);
        }
    }

    if (filters.length !== 0) {
        document.querySelector(".ms_filter_container > .ms_filters").innerHTML = filters.join('');
        watchFilterInputs();
    } else {
        document.getElementsByClassName("ms_list_filter_bot")[0].style.display = "none";
    }

    //add event listener for products select to open options
    if (document.getElementsByClassName('ms_selectMultiList').length > 0) {
        var labels = document.querySelectorAll('.ms_selectMultiList_label');

        for (var j = 0; j < labels.length; j++) {
            labels[j].addEventListener("click", ms_show_products_filter_options);
        }
    }
}

function ms_show_products_filter_options(event) {
    event.stopPropagation();
    var labelClass = 'ms_selectMultiList_label';
    if (!this.classList.contains(labelClass)) { return; }

    if (this.classList.contains('is-active')) {
        this.classList.remove('is-active')
    } else {
        this.classList.add('is-active')
    }
}

function ms_isFilterDisabled(currentFilter, disabledFilters) {
    return disabledFilters[currentFilter.key];
}

//run through the list of closest points and, if these don't have matches with a filter, it will hide them
function ms_clear_filters() {
    if (ms_closest.length > 0 && ms_av_filters.length > 0) {
        //go through array of filters to check
        var has = {};
        if (ms_av_filters.length) {
            for (var ii = 0, l = ms_av_filters.length; ii < l; ii++) {
                var ex = 0;
                for (var i = 0, len = ms_closest.length; i < len; i++) {
                    if (ms_closest[i].info.hasOwnProperty(ms_av_filters[ii]) && (ms_closest[i].info[ms_av_filters[ii]].length || ms_closest[i].info[ms_av_filters[ii]] > 0)) ex++;
                }
                has[ms_av_filters[ii]] = ex;

                //if there's no contact with this filter, disable it
                var f = document.querySelector(".ms_filters .ms_filter_option  > input[data-category='" + (ms_av_filters[ii] === "Type" ? "MapType" : ms_av_filters[ii]) + "']");

                ex === 0 ? f.parentNode.parentNode.classList.add('is-disabled') : '';
            }
        }
    }
}

function reduce_dealers(closest) {
    //we want to reduce dealers by using filter options, we dont want to select them, just reduce it and use Mapsearch as usual.
    if (ms_has_valid_url_prams && ms_url_params) {
        var filters = {};
        Object.keys(ms_url_params).forEach(function (k) {
            var element = ms_url_params[k];
            var key = k.charAt(0).toUpperCase() + k.slice(1);

            element.indexOf(',') > -1 ? filters[key] = element.split(',') : filters[key] = element;
        });

        ms_filtered = use_filters(closest, filters);

        ms_markers.Data = ms_markers.Data.filter(function (marker) {
            var result = ms_filtered.filter(function (filter) {
                return marker.PspId == filter.info.PspId;
            })

            return result.length > 0;
        })
    }

    jQuery('#mapSearchLoad').addClass("fadeout");
}


function use_filters(ms_filtered, filters) {
    //type (if it's not defined or empty, don't filter)
    if (typeof (filters.MapType) !== "undefined" && filters.MapType) {
        ms_filtered = ms_filtered.filter(function (el) {
            return el.info.Type == filters.MapType;
        });
    }
    if (typeof (filters.SubTypes) !== "undefined" && filters.SubTypes) {
        ms_filtered = ms_filtered.filter(function (el) {
            var pe = el.info.SubType.filter(function (p) {
                return p.Id == filters.SubTypes;
            });
            return pe.length > 0;
        });
    }
    if (typeof (filters.Status) !== "undefined" && filters.Status) {
        ms_filtered = ms_filtered.filter(function (el) {
            var pe = el.info.Status.filter(function (p) {
                return p.Id == filters.Status;
            });
            return pe.length > 0;
        });
    }
    if (typeof (filters.Services) !== "undefined" && filters.Services) {
        ms_filtered = ms_filtered.filter(function (el) {
            var pe = el.info.Services.filter(function (p) {
                return p.Id == filters.Services;
            });
            return pe.length > 0;
        });
    }
    if (typeof (filters.Certificates) !== "undefined") {
        ms_filtered = ms_filtered.filter(function (el) {
            if (Array.isArray(filters.Certificates)) {
                var CertificatesFound = 0;
                for (var i = 0; i < el.info.Certificates.length; i++) {
                    if (filters.Certificates.indexOf(el.info.Certificates[i].Id) > -1) {
                        CertificatesFound++;
                    }
                }
                if (CertificatesFound === filters.Certificates.length) {
                    return true;
                }
            } else {
                var pe = el.info.Certificates.filter(function (p) {
                    return p.Id == filters.Certificates;
                });
                return pe.length > 0;
            }
        });
    }
    if (typeof (filters.Products) !== "undefined") {
        ms_filtered = ms_filtered.filter(function (el) {
            if (Array.isArray(filters.Products)) {
                var productsFound = 0;
                for (var z = 0; z < el.info.Products.length; z++) {
                    if (filters.Products.indexOf(el.info.Products[z].Id) > -1) {
                        productsFound++;
                    }
                }
                if (productsFound === filters.Products.length) {
                    return true;
                }
            } else {
                var pe = el.info.Products.filter(function (p) {
                    return p.Id == filters.Products;
                });
                return pe.length > 0;
            }

        });
    }
    if (typeof (filters.ProductCount) !== "undefined" && filters.ProductCount !== "") {
        ms_filtered = ms_filtered.filter(function (el) {
            if (filters.ProductCount === "0") {
                return el.info.ProductCount < 1;
            } else {
                return el.info.ProductCount >= filters.ProductCount;
            }
        });
    }

    return ms_filtered;
}

//set filters and filters out the list
function ms_set_filters(hideFilterSection) {
    //only run this if there are elements in the "closest" list
    if (ms_closest.length > 0) {
        //my selected filters
        var filters = {};
        //tracking - i make another object for tracking these filters
        var filters_tr = {};
        //set value and label name for tags
        var tags = [];
        //look at the selected options and create a filters object
        var sel = document.querySelectorAll('.ms_filter_container > .ms_filters > .ms_filter .ms_filter_option input[type="radio"]:checked');
        for (var i = 0, len = sel.length; i < len; i++) {
            var k = sel[i].getAttribute("data-category");
            var v = sel[i].value;
            filters[k] = v;
            //tracking - the filter tracking needs the name, so I make a new var with the selected value label 
            var filter_label = sel[i].parentNode.innerText;
            filters_tr[k] = filter_label;
            //tags
            tags.push({
                id: v,
                name: filter_label,
                category: k
            });
        }
        //add to filters list multiselect values
        var multiSel = document.querySelectorAll('.ms_filter_container > .ms_filters > .ms_filter .ms_filter_option > input[type="checkbox"]');
        if (multiSel.length > 0) {
            var filters_tr_multiSelect = [];
            for (var ii = 0, lenn = multiSel.length; ii < lenn; ii++) {
                var kk = multiSel[ii].getAttribute("data-category");
                // make filters products list as array
                if (!filters[kk]) {
                    filters[kk] = [];
                } else if (filters[kk].constructor !== Array) {
                    //if filter products has value from url params
                    filters[kk] = filters[kk].split(',');
                }

                if (multiSel[ii].checked) {
                    var vv = multiSel[ii].value;
                    var selectedText = multiSel[ii].parentNode.innerText;
                    var n = selectedText.length > 0 ? selectedText : "Empty";
                    //tracking 
                    filters_tr_multiSelect.push(n);
                    //filters
                    filters[kk].push(vv);
                    //tags
                    tags.push({
                        id: vv,
                        name: n,
                        category: kk
                    });
                }
            }
            //add multiple selected elements as a string list to tracking array
            filters_tr[kk] = filters_tr_multiSelect.join();
        }

        //only keep list items that have these properties
        ms_filtered = use_filters(ms_closest, filters);

        ms_print_list(ms_filtered, false);

        if (!hideFilterSection) {
            ms_filter_display();
        }

        //"filters_tr" contains names of the selections rather then "filters" variable contains values (id's)
        ms_show_filter_tags(Object.values(tags));

        //if i'm on mobile, jump to the list
        ms_jump(document.getElementById("mapSearchList"));

        //track the filter list
        ms_registerDataLayer("Filter", JSON.stringify(filters_tr));
    }
    fixSidebarHeight();
}

function ms_show_filter_tags(tags) {
    var tags_container = document.querySelector('#mapSearchList .ms_filter_tags');

    if (!tags || tags.length === 0) {
        tags_container.classList.add('is-hidden');
    } else {
        tags_container.classList.remove('is-hidden');
    }

    var filtered_tags = [];
    for (var i = 0; i < tags.length; i++) {
        var tag = [
            '<div class="ms_filter_tags_element" data-category="' + tags[i].category + '" data-id="' + tags[i].id + '" onclick="update_filtered_listed_based_on_tags(this); return;">' + tags[i].name + '<i class="far fa-times"></i></div>'
        ].join('');

        filtered_tags.push(tag);
    }

    tags_container.innerHTML = filtered_tags.join('');
}


function update_filtered_listed_based_on_tags(tag) {
    //unselect radio and checkboxes
    var filter_id = tag.getAttribute('data-id');
    var filter_category = tag.getAttribute('data-category');
    //todo: check if possible to checked= true data-checked true not click
    document.querySelector('.ms_filters input[data-category="' + filter_category + '"][value="' + filter_id + '"]').click();
    ms_set_filters(true);
}

/* more info (overlay with information of dealer/installer). */
function ms_more_info(id) {
    ms_getContactsById(id, ms_more_info_show);
}

function ms_more_info_show(inf) {
    //geting data from getContactsById API
    var info = inf.Data[0],
        mobile_list_location = document.querySelector('#mapSearchContainer > .ms_list_item_map_view .ms_list_item.ms_list_item_clicked .ms_list_expanded'),
        desktop_list_location = document.querySelector('#mapSearchList .ms_list_container .ms_list_item.ms_list_item_clicked .ms_list_expanded'),
        ms_infoContent = (ms_mobile_view_option === 'map' && window.innerWidth < 768) ? mobile_list_location : desktop_list_location;

    if (ms_infoContent === null) {
        return;
    }

    var ms_infoWeb = ms_infoContent.querySelector(".ms_info_web");

    if (info.Telephone1 !== null) {
        ms_infoContent.querySelector(".ms_info_phone_container .ms_info_phone_number > a").innerHTML = info.Telephone1;
        ms_infoContent.querySelector(".ms_info_phone_container .ms_info_phone_number > a").href = 'tel: +' + info.Telephone1;
        ms_infoContent.querySelector(".ms_info_phone_container > a").setAttribute("data-label", info.FullName + " | " + info.Telephone1);
    } else {
        ms_infoContent.querySelector(".ms_info_phone_container").style.display = "none";
    }

    if (info.Email !== null) {
        ms_infoContent.querySelector(".ms_info_email").href = "mailto:" + info.Email;
    } else {
        ms_infoContent.querySelector(".ms_info_email_container").style.display = "none";
    }

    if (info.WebAddress !== null) {
        ms_infoWeb.href = info.WebAddress;
    } else {
        ms_infoWeb.style.display = "none";
    }

    ms_infoContent.querySelector(".ms_i_navigation").href = "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(info.FullAddress) + "&origin=" + encodeURIComponent(document.getElementById('mapSearchInput').value);

    //search for the opening hours (using google api)
    var service = new google.maps.places.PlacesService(document.getElementById('ms_info_autocomplete'));
    var search = service.textSearch({ query: info.FullName + ", " + info.FullAddress }, function (response, status, pagination) {
        if (status === google.maps.GeocoderStatus.OK && response.length > 0) {
            service.getDetails({ placeId: response[0].place_id }, function (place, status) {

                if (place.opening_hours) {
                    var opening = "";
                    for (var i = 0, len = place.opening_hours.weekday_text.length; i < len; i++) {
                        opening += "<div>" + place.opening_hours.weekday_text[i] + "</div>";
                    }
                    ms_infoContent.querySelector(".ms_info_times").innerHTML = opening;
                } else {
                    //hide label and data if no data present
                    ms_infoContent.querySelector(".ms_info_times").setAttribute('style', 'display: none;');
                    ms_infoContent.querySelector(".ms_info_times_label").setAttribute('style', 'display: none;');
                }
            });
        }
    });

    //Get the Services
    if (info.Services.length > 0) {
        var services = [];
        for (var i = 0, len = info.Services.length; i < len; i++) {
            services.push(info.Services[i].Name);
        }
        ms_infoContent.querySelector(".ms_info_ad_services div").innerHTML = services.join(', ');
    } else {
        ms_infoContent.querySelector(".ms_info_ad_services").style.display = "none";
    }

    //Get the Other Services
    if (info.AdditionalService) {
        if (Array.isArray(info.AdditionalService)) {
            var services = [];
            for (var i = 0, len = info.AdditionalService.length; i < len; i++) {
                services.push(info.AdditionalService[i].Name);
            }
            ms_infoContent.querySelector(".ms_info_ad_other_services div").innerHTML = services.join(', ');
        }
        else {
            ms_infoContent.querySelector(".ms_info_ad_other_services div").innerHTML = info.AdditionalService;
        }
    } else {
        ms_infoContent.querySelector(".ms_info_ad_other_services").style.display = "none";
    }

    //get the Status
    if (info.Status.length > 0) {
        var st = [];
        for (var i = 0, len = info.Status.length; i < len; i++) {
            st.push(info.Status[i].StatusName);
        }
        ms_infoContent.querySelector(".ms_info_ad_status div").innerHTML = st.join(', ');
    } else {
        ms_infoContent.querySelector(".ms_info_ad_status").style.display = "none";
    }

    //Get the Products
    if (info.Products.length > 0) {
        var products = [];
        for (var i = 0, len = info.Products.length; i < len; i++) {

            var product = [
                '<div class="ms_info_ad_products_element_row">',
                info.Products[i].ProductImageSrc ? '<img src="' + info.Products[i].ProductImageSrc + '" />' : '',
                '<span>' + info.Products[i].Name + '</span>',
                '</div>'
            ].join('');

            products.push(product);
        }

        ms_infoContent.querySelector(".ms_info_ad_products_element").innerHTML = products.join('');
    } else {
        ms_infoContent.querySelector(".ms_info_ad_products").style.display = "none";
    }

    // Get the certificates
    if (info.Certificates.length > 0) {
        var certificates = [];
        var ul = ms_infoContent.querySelector(".certificate_list");

        for (var c = 0; c < info.Certificates.length; c++) {
            var certificate = [
                '<li> <i class="far fa-file-certificate"></i>' + info.Certificates[c].CertificateName + '</li>'
            ].join('');

            certificates.push(certificate);
        }
        ul.innerHTML = certificates.join('');
    } else {
        ms_infoContent.querySelector(".ms_info_certificate").style.display = "none";
    }

    //tracking
    ms_registerDataLayer("More Info", info.FullName);
}

function openDealerContactForm() {
    var emailElements = document.querySelectorAll('.ms_info_email_container')
    var form = document.querySelector('.ms_contactForm');

    emailElements.forEach(function (element) {
        element.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (ms_Settings && ms_Settings.Form) {
                form.classList.add('is-active');
                var emailAddress = element.querySelector('.ms_info_email').href.replace('mailto:', '');
                var pspId = element.closest('.ms_list_item').dataset.id;
                var dealerName = jQuery(element).closest('.ms_list_item').find('.ms_list_info_title').text();

                form.querySelector('input[name="installer_dealer_email"]').value = emailAddress;
                form.querySelector('input[name="pspid"]').value = pspId;
                form.querySelector('input[name="name_of_installer_dealer"]').value = dealerName;
                form.querySelector('input[name="unsubscribe_language"]').value = jQuery('#hfCurrentLanguage').val();

                form.querySelector('.ms_contactForm_close').addEventListener('click', function () {
                    form.classList.remove('is-active');
                })

                form.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            } else {
                window.open(element.querySelector('.ms_info_email').href);
            }
        });
    });
}

/* jump to certain point of the map/list on mobile */
function ms_jump(to) {
    if (window.innerWidth < 768) {
        jQuery("html, body").animate({
            scrollTop: jQuery(to).offset().top
        }, 600);
    }
}



// creates dictionary where each type is active or not active
function GetTypesActiveDictionary() {
    var activeTypes = {};
    jQuery.each(ms_Settings.MapType, function (i, value) {
        activeTypes[value.Id] = value.IsActive;
    });

    return activeTypes;
}

//get parameters from url
function getJsonFromUrl() {
    var query = location.search.substr(1);
    var result = {};
    query.split("&").forEach(function (part) {
        var item = part.split("=");
        result[item[0].toLocaleLowerCase()] = decodeURIComponent(item[1]); // Setting lowercase to disregard case sensitive URL
    });
    return result;
}

function SelectHasValueIfExists(select, value) {
    obj = document.getElementById(select);

    if (obj !== null) {
        return (obj.innerHTML.indexOf('value="' + value + '"').setAttribute("selected") > -1);
    } else {
        return false;
    }
}


/*
MAP SEARCH TRACKING
*/

//will only be true in the beginning
var ms_start = true;
var ms_track_label = false;

function ms_registerDataLayer(action, label) {
    if (typeof (dataLayer) !== "undefined") {
        var data = {
            'event': 'interactioneventga',
            'eventcategory': "Map search",
            'eventaction': action,
            'eventlabel': label,
            'eventnoninteraction': false
        };
        dataLayer.push(data);
    }
}

//when the user has interacted, but have't chosen an installer
window.addEventListener("unload", function (e) {
    if (!ms_start && ms_track_label) {
        ms_registerDataLayer("Abandon", ms_track_label);
    }
});

/* Copy MapSearch settings to URL functions */
function ms_copy_link(pspid, event) {
    if (event) {
        event.stopPropagation();
        if (window.innerWidth < 768) {
            window.scrollTo({
                left: 0,
                top: 0,
            })
        }

    }

    var query = window.location.origin + window.location.pathname + '?',
        productInputs = document.querySelectorAll("#mapSearchList .ms_filters input[data-category='Products']:checked:enabled");

    query = query + 'loc=' + document.getElementById('mapSearchInput').value;

    if (pspid && typeof pspid === 'string') {
        query = query + '&pspid=' + pspid;
    }

    jQuery(ms_filters).each(function (index, value) {
        var inputValue = jQuery("#mapSearchList .ms_filters input[data-category='" + value.key + "']:checked:enabled").val();

        //Products are multi selectable items
        if (productInputs && value.key === 'Products') {
            query = query + '&' + value.key + '=';
            //then add product Id's seperated by comma
            for (var i = 0; i < productInputs.length; i++) {
                i === 0 ? query = query + productInputs[i].value : query = query + ',' + productInputs[i].value;
            }

        } else if (inputValue && value.key !== 'Products') {
            query = query + '&' + value.key + '=' + inputValue;
        }


    });

    ms_fill_copy_field(query);

    return query;
}
function ms_copy_result_to_clipboard() {
    var activeResult = document.querySelector('.ms_list_item_clicked'),
        activeId = activeResult.dataset.id,
        query = ms_copy_link();

    query = query + '&pspid=' + activeId;

    ms_fill_copy_field(query);
}
function ms_fill_copy_field(e) {
    var copyField = document.getElementById('ms_copy_link_bar');
    copyField.classList.add('active');
    copyField.querySelector('input').value = e;
}
function ms_copy_to_clipboard() {
    var copyField = document.getElementById('ms_copy_link_field');
    copyField.select();
    copyField.setSelectionRange(0, 99999); /*For mobile devices*/
    document.execCommand("copy");
}
function ms_toggleDistanceAndFilter(show) {
    if (!show) {
        document.getElementById('mapSearchList').classList.add('hide-filter');
    } else {
        document.getElementById('mapSearchList').classList.remove('hide-filter');
        document.getElementById('mapSearchList').classList.remove('hide-filter');
    }
}
function sortByRanking(closest) {
    //if sorting by ranking points, re-sort the list
    if (ms_Settings.StandardSorting === 'ranking') {
        /* Filter out the values with value 0 (RankingPoint not set) */
        var part1 = [], part2 = [];

        for (var i = 0, len = closest.length; i < len; i++) {
            if (closest[i].info.RankingPoint === "0") {
                part2.push(closest[i]);
            } else {
                part1.push(closest[i]);
            }
        }

        part1.sort(function (a, b) {
            return b.info.RankingPoint - a.info.RankingPoint;
        });

        return part1.concat(part2);
    }
}